import { TaskStatus, TaskPriority, /* TaskCategory */ } from '../interfaces/flowTask.interface';
import { colors, alphaVar } from "../../ui/colors";

export const TASK_STATUSES: TaskStatus[] = ['TODO', 'IN_PROGRESS', 'DONE'];

export const TASK_PRIORITIES: TaskPriority[] = ['LOW', 'MEDIUM', 'HIGH'];

export const TASK_CATEGORIES/* : TaskCategory[] */ = ['JOB', 'QUOTE'];

export const STATUS_COLORS = {
  TODO: {
    bg: alphaVar(colors.gray[400], 0.12),
    color: colors.gray[700],
    border: colors.gray[300],
  },
  IN_PROGRESS: {
    bg: alphaVar(colors.blue[500], 0.12),
    color: colors.blue[700],
    border: colors.blue[300],
  },
  DONE: {
    bg: alphaVar(colors.success[500], 0.12),
    color: colors.success[700],
    border: colors.success[300],
  },
};

export const PRIORITY_COLORS = {
  LOW: {
    bg: alphaVar(colors.gray[400], 0.12),
    color: colors.gray[600],
  },
  MEDIUM: {
    bg: alphaVar(colors.warning[400], 0.12),
    color: colors.warning[700],
  },
  HIGH: {
    bg: alphaVar(colors.danger[400], 0.12),
    color: colors.danger[700],
  },
};

export const CATEGORY_COLORS = {
  JOB: {
    bg: alphaVar(colors.blue[500], 0.12),
    color: colors.blue[700],
  },
  QUOTE: {
    bg: alphaVar(colors.orange[400], 0.12),
    color: colors.orange[700],
  },
};

export const MENTION_TYPES = {
  JOB: 'JOB',
  QUOTE: 'QUOTE',
  CLIENT: 'CLIENT',
} as const;

export const MENTION_PATTERNS = {
  JOB: /@Job-(\d+)/g,
  QUOTE: /@Quote-(\d+)/g,
  CLIENT: /@Client-(\d+)/g,
};

